export const disablePageScrolling = () => {
  const bodyOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';

  return () => {
    document.body.style.overflow = bodyOverflow;
  };
};
